// src/enums/index.js

export const DifficultyLevel = {
    EASY: "easy",
    MEDIUM: "medium",
    HARD: "hard",
};

export const QuestionType = {
    STRUCTURE: "structure",
    BRAINSTORM: "brainstorm",
    MATH: "math",
    RECOMMENDATION: "recommendation",
};

export const CaseType = {
    MARKET_ENTRY: "market_entry",
    PROFITABILITY: "profitability",
    M_AND_A: "m_and_a",
    OPERATIONS: "operations",
};

export const Industry = {
    HEALTHCARE: "healthcare",
    TECHNOLOGY: "technology",
    RETAIL: "retail",
    AUTOMOTIVE: "automotive",
    FINANCE: "finance",
    AGRICULTURE: "agriculture",
    CPG: "cpg",
    ENERGY: "energy",
    FINANCIAL_SERVICES: "financial_services",
    LOGISTICS: "logistics",
    MANUFACTURING: "manufacturing",
    NON_PROFIT: "non_profit",
    PROFESSIONAL_SERVICES: "professional_services",
    PUBLIC_SECTOR: "public_sector",
    REAL_ESTATE: "real_estate",
    TEST: "test",
    TMT: "tmt",
    TRAVEL: "travel",
};
